<template>
	<div class="animated fadeIn attributes--attributes-list">
		<b-row id="attributes-header-nav">
			<b-col md="6">
				<h1 id="attributes-header-nav-txt">Attributes List  <records-count :total="pageInfo.totalItems"/></h1>
			</b-col>
			<b-col md="6">
				<div class="buttons-panel">
					<b-button
						@click="add()"
						size="sm"
						title="Add"
						style="float: right;margin-bottom: 5px;"
					>
						<i class="fa fa-plus" aria-hidden="true"></i>
					</b-button>
				</div>
			</b-col>
		</b-row>
		<b-row>
			<b-col>
				<div style="margin-top: 41px;" class="card">
					<div class="card-body">
						<Grid
							class="grid"
							:pageable="pageable"
							:resizable="true"
							:reorderable="true"
							:sortable="true"
							:row-height="25"
							selected-field="selected"
							:data-items="itemData"
							:page-size="pageInfo.pageSize"
							:total="pageInfo.totalItems"
							:take="take"
							:skip="skip"
							:columns="prepareColumnsData({ initialColumns: fields, settingsColumns: gridSettings.columns })"
							:sort="sortDetails"
							@pagechange="handlePageChange"
							@columnresize="handleColumnResize"
							@sortchange="handleSortChange"
							@columnreorder="handleColumnReorder"
							@rowclick="onRowClick"
						>
						<template v-slot:commandsHeader="{props, listeners}" >
							<div class="d-flex justify-content-center">
							<grid-settings :gridId="gridId" :fields="fields" class="mr-2" />
							<!-- <b-form-checkbox v-model="checkAllRows" /> ENABLE FOR CHECKBOX SELECT/DESELECT ALL-->
							</div>
						</template>
						<template v-slot:commands="{props}">
							<td>
							<div class="d-flex justify-content-center">                
								<i @click="pushToDetails(props)" class="table-action-icon-edit fa fa-edit"></i>                
							</div>
							</td>
						</template>

						<template v-slot:dateCreated="{props}"><td>{{ props.dataItem.dateCreated | date }}</td></template>
<template v-slot:dateModified="{props}"><td>{{ props.dataItem.dateModified | date }}</td></template>

										
						</Grid>
					</div>

				</div>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { debounce, unionBy } from 'lodash';

import { dateTime, date } from '@/shared/filters';
import { SORT_ORDER, GRID_PAGE_SIZES, PAGE_SIZE, GRID_ID } from '@/shared/constants';
import { sortChange, prepareColumnsData } from '@/shared/helpers';
import GridSettings from '@/shared/components/GridSettings';

import gridFields from './fields';

const SEARCH_DEBOUNCE_TIME = 750;

export default {
	components: {
		GridSettings,
  },
  metaInfo: () => ({
    title: 'Attributes',
  }),  
	data() {
		return {
			prepareColumnsData,
			pageNumber: 1,
			skip: 0,
			take: PAGE_SIZE,
			filtersVisible: false,
			fields: gridFields,
			gridId: GRID_ID.ATTRIBUTES,
			pageable: {
				pageSizes: GRID_PAGE_SIZES,
			},
      		selectedRowItemId: 0,
		};
	},
	computed: {
		...mapGetters('attributes', [
			'attributesList',
			'attribute',
			'pageInfo',
			'sortBy',
			'sortOrder',
			'searchQuery',
			'selectedItemId' 
		]),
		...mapGetters('account', ['gridSettingsById']),
		filterButtonName() {
			return this.filtersVisible ? 'Hide advanced' : 'Advanced';
		},
		isSortDesc: function() {
			return this.sortOrder == SORT_ORDER.DESC;
		},
		emptyMessage: function() {
			return this.searchQuery
				? `No attributes <span class="text-primary">${this.searchQuery}</span> found`
				: 'No attributes found';
		},
		sortDetails: function() {
			if (this.sortBy) {
				return [{ field: this.sortBy, dir: this.sortOrder.toLowerCase() }];
			}

			if (this.gridSettings.sort) {
				return [
					{
						field: this.gridSettings.sort.sortBy,
						dir: this.gridSettings.sort.sortOrder.toLowerCase(),
					}
				];
			}

			return [];
		},
		gridSettings() {
			return this.gridSettingsById(this.gridId);
		},
		itemData() {
			return this.attributesList.map((attribute) => ({ ...attribute, selected: attribute.id === this.selectedRowItemId }));
		},
		//This function checks/unchecks all rows --ENABLE WHEN USING CHECKBOXES ON THE ROWS		
    // checkAllRows: {
    //   get() {
    //     return this.users ? this.checkedRowItemIds.length == this.attributes.length : false;
    //   },
    //   set(value) {
    //     const checked = [];

    //     if(value) {
    //       this.attributes.forEach((attribute) => {
    //         checked.push(attribute.lineId);
    //       });
    //     }

    //     this.checkedRowItemIds = checked;
    //   }
    // },
	},
	filters: {
		dateTime,
	},
	methods: {		
		...mapActions('attributes', ['getAll', 'getById', 'sort', 'getPage', 'remove', 'search', 'select']),
		...mapActions('account', ['saveGridSettings']),
		handlePageChange(event) {
			this.skip = event.page.skip;
			this.take = event.page.take;
			const newPageNumber = Math.floor(event.page.skip / event.page.take) + 1;

			if (this.pageNumber !== newPageNumber) {
				this.pageNumber = newPageNumber;
				this.getPage(this.pageNumber);
			}
		},
		handleColumnResize: debounce(function({ columns }) {
			const newColumns = prepareColumnsData({
				columns,
				initialColumns: gridFields,
				settingsColumns: this.gridSettings.columns,
			});

			this.saveGridSettings({
				id: this.gridId,
				settings: { columns: newColumns },
				initialColumns: gridFields,
			});
		}, 500),
		handleColumnReorder({ columns }) {
			const newColumns = prepareColumnsData({
				columns,
				initialColumns: gridFields,
				settingsColumns: this.gridSettings.columns,
			});

			this.saveGridSettings({
				id: this.gridId,
				settings: { columns: newColumns },
				initialColumns: gridFields,
			});
		},
		handleSortChange({ sort }) {
			sortChange({
				sortBy: this.sortBy,
				sortData: sort,
				gridId: this.gridId,
				saveGridSettings: this.saveGridSettings,
			});
		},
		pageChangeHandler: function(event) {
			this.skip = event.page.skip;
			this.take = event.page.take;
			this.pageNumber = Math.floor(event.page.skip / event.page.take) + 1;

			this.getAll({
				...this.gridSettings.sort,
				pageSize: this.take,
				pageNumber: this.pageNumber,
			});
		},
		onSearch: debounce(function(e) {
			this.search(e);
		}, SEARCH_DEBOUNCE_TIME),
		onRowClick: function(event) {
			this.edit(event.dataItem);
		},
		edit(item) {
			this.$router.push({ name: 'attributes.edit', params: { id: item.id } });
		},
		add() {
			this.$router.push({ name: 'attributes.add' });
		},
		onRowClick(row) {
		this.selectedRowItemId = row.dataItem.id;
		// const { id, detailsVisible } = row.dataItem;
		// this.select({ id, isChecked: !detailsVisible });
		},
		pushToDetails(row) {
			this.$router.push({
			name: 'attributes.edit',
			params: { id: row.dataItem.id },
		});
		},
	},
	watch: {
		pageInfo: function(newPageInfo) {
			this.pageNumber = newPageInfo.pageNumber;
			this.take = newPageInfo.pageSize;
		},
		take(pageSize) {
			this.saveGridSettings({
				id: this.gridId,
				settings: {
					...this.gridSettings,
					pageSize,
				},
			});
		},
    attributesList() {
			//This function sets the first row as the selected row
      if(this.attributesList.length > 0 && this.selectedRowItemId === 0){
        this.selectedRowItemId = this.attributesList[0].id;
        const { id, detailsVisible } = this.attributesList[0];
        this.select({ id, isChecked: !detailsVisible });
      }
    },
	},
	mounted() {
		this.skip = this.pageInfo.pageNumber * this.pageInfo.pageSize - 1;
		this.take = this.pageInfo.pageSize;

		this.getAll({
			...this.gridSettings.sort,
			pageSize: this.gridSettings.pageSize || this.take,
		});
	},
	beforeDestroy() {
		this.select({ id: null, isChecked: false });
	},
};
</script>

<style lang="scss">
@import '@/assets/scss/_colors.scss';

#attributes-header-nav {
    width: 100%;
    z-index: 1000;
    position: fixed;
    border-bottom: 1px solid rgb(200, 206, 211);
    background: #fff;
}

#attributes-header-nav-txt {
  background-color: #fff;
  padding: 8px;
  font-size: 20px;
  margin: 0px;
}


.attributes {
  &--attributes-list {
    .tools > * {
      margin: 0 0 0 3px;
    }
    .b-pagination {
      justify-content: center;
    }
    .create-ultra-rfp {
      margin-top: 0.5em;
      margin-bottom: 1em;
    }
    table td {
      cursor: pointer;
    }
    .buttons-panel {
      text-align: right;
      margin-right: 30px;
      margin-top: 7px;
      .btn {
        margin-left: 5px;
      }
    
    }
    .clear-filter-button-container {
      margin-top: 12px;
      text-align: right;
    }
  }

  &--grid-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

/* .highlight {
  background: rowSelection !important;
} */

.b-pagination {
  justify-content: center;
}

.tools > * {
  margin: 0 0 0 3px;
}

#KendoGrid .k-virtual-scrollable-wrap table {
	min-width: 800px;
}
</style>
